class Actions {
  // Alterna lo stato di riproduzione di un video e sincronizza l'UI
  // - Aggiorna lo stato visuale del pulsante
  // - Imposta l'aria-label appropriata per l'accessibilità
  static toggleVideoState = (source, video) => {
    if(video.paused) {
      source.classList.add('video-playing');
      source.ariaLabel = source.dataset.labeloff;
      video.play();
    }
    else {
      source.classList.remove('video-playing');
      source.ariaLabel = source.dataset.labelon;
      video.pause();
            
    }
  }
}